import { getAuctionCatalogue } from './auctionCatalogueClient';

export const getYearsWithAuctions = async (context = {}, brandId, modelId, options) => {
  if (!brandId || !modelId) return [];
  return getAuctionCatalogue('getYearsWithAuctionsV2', context, {brandId, modelId}, options);
};
